/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderDto } from './orderDto';
import { OrderLog } from './orderLog';
import { CleanablePairRouteOrderRouteOrderAck } from './cleanablePairRouteOrderRouteOrderAck';

export interface OrderDetailsDto {
  order?: OrderDto;
  orderLogs?: Array<OrderLog>;
  routes?: Array<CleanablePairRouteOrderRouteOrderAck>;
}
